import { Route } from 'lucide-react'
import { Link } from 'react-router-dom'
import { usePerformanceScope } from '@/lib/use-performance-scope'

/** Shows which tour/show is active in the sidebar switcher. */
export function PerformanceScopeBanner() {
  const { isScoped, scopeLabel, kind } = usePerformanceScope()

  if (!isScoped) {
    return (
      <div className="mb-4 rounded-md border border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900">
        No performance selected — showing all data.{' '}
        <Link to="/performances" className="font-medium underline">
          Pick a tour or show
        </Link>{' '}
        to scope this section.
      </div>
    )
  }

  return (
    <div className="mb-4 flex items-center gap-2 rounded-md border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm text-emerald-900">
      <Route className="h-4 w-4 flex-shrink-0" />
      <span>
        Scoped to <strong>{scopeLabel}</strong>
        <span className="text-emerald-700"> ({kind === 'tour' ? 'tour' : 'show'})</span>
      </span>
      <Link to="/performances" className="ml-auto text-xs font-medium underline">
        Change
      </Link>
    </div>
  )
}
